import { useState, useEffect, useContext } from 'react'
import { LogoMobile } from './Logo'
import CloseIcon from '@mui/icons-material/Close'
import MenuIcon from '@mui/icons-material/Menu'
import MobileDrawer from './MobileDrawer'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { useLocation, useNavigate } from 'react-router-dom'
import { Logout, SettingsOutlined } from '@mui/icons-material'
import { gql, useMutation } from '@apollo/client'
import { toast } from 'react-toastify'
import { GET_USER } from 'context/UserProvider'
import { UserContext } from 'context'

const MobileNav = () => {
  const location = useLocation()
  const [open, setOpen] = useState(false)
  const { user } = useContext(UserContext)
  const navigate = useNavigate()

  const [logout] = useMutation(LOGOUT, {
    onError: (err) => {
      toast.dismiss()
      console.error(err)
      toast.error('Error logging out')
    },
    onCompleted: () => {
      localStorage.setItem('sessionTimeout', JSON.stringify(false))
      window.location.reload()
    },
    refetchQueries: [{ query: GET_USER }]
  })

  const handleClose = () => setOpen(false)
  const handleOpen = () => setOpen(true)

  const openWhatsApp = () => {
    const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    if (isMobileDevice) {
      window.location.href = `${process.env.REACT_APP_CHAT_WHATSAPP_LINK}`
      navigate('/')
    } else {
      window.open(`${process.env.REACT_APP_CHAT_WEB_WHATSAPP_LINK}`, '_blank')
      navigate('/')
    }
  }
  const openSettings = () => {
    navigate('/settings')
  }

  useEffect(() => {
    handleClose()
  }, [location])

  return (
    <section id="mobile-nav">
      <LogoMobile />
      <WhatsAppIcon style={{ marginLeft: 145 }} onClick={openWhatsApp} />
      {user.role === 'super_admin' && <SettingsOutlined style={{ marginLeft: 10, marginRight: 10 }} onClick={openSettings} />}
      {!user.godmode && (<Logout style={{ marginLeft: 10, marginRight: 10 }} onClick={logout} />)}
      {open ? <CloseIcon onClick={handleClose} /> : <MenuIcon onClick={handleOpen} />}
      <MobileDrawer open={open} setOpen={setOpen} />
    </section>
  )
}

const LOGOUT = gql`
  mutation logout {
    logout
  }
`

export default MobileNav


